import { useMemo, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { formatSeconds, calculateDuration } from '../utils/helpers';
import { useGameRoundData } from './useGameRoundData.ts';

export const useGameRoundSliderDurationRenderData = () => {
  const [timeDifference, setTimeDifference] = useState(0);

  const { data: roundData } = useGameRoundData();

  const currentTime = useMemo(
    () => (timeDifference ? formatSeconds(timeDifference) : '0:00'),
    [timeDifference]
  );

  const durationInSeconds = useMemo(() => {
    const start = roundData?.startAt ?? 0;
    const end = roundData?.endAt ?? 0;
    return calculateDuration(start, end);
  }, [roundData?.startAt, roundData?.endAt]);

  const durationToRender = useMemo(
    () => formatSeconds(durationInSeconds),
    [durationInSeconds]
  );

  useEffect(() => {
    if (!roundData?.startAt) return;

    const updateTimer = () => {
      const now = dayjs();
      const startTime = dayjs(roundData.startAt);
      let diffInSeconds = Math.max(0, now.diff(startTime, 'second'));
      const endTime = roundData?.startAt ? dayjs(roundData.endAt) : null;
      if (endTime) {
        diffInSeconds = Math.min(
          diffInSeconds,
          endTime.diff(startTime, 'second')
        );
      }
      setTimeDifference(diffInSeconds);
    };

    updateTimer();

    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [roundData?.startAt, roundData?.endAt]);

  return { currentTime, timeDifference, durationInSeconds, durationToRender };
};
